import { Tag } from '@hub/shared'
import { useTranslation } from 'react-i18next'
import './campaign-footer-status.component.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  label: string
  icon?: JSX.Element
}

export default ({ label, icon, ...props }: Props) => {
  const [t] = useTranslation('campaignFooterStatus')

  return (
    <section className="campaign-footer-status display-flex justify-content-center align-items-center" {...props}>
      <Tag
        icon={<span className="icon-footer-status">{icon}</span>}
        labels={
          <p>
            {t('Status')}: <strong>{label}</strong>
          </p>
        }
      />
    </section>
  )
}
